module.exports = __webpack_public_path__ + "assets/88963f2c08d2862851ebe286162e84ff.mp4";